module.exports = __webpack_public_path__ + "71c6f10e201cfb70e77c61a513d62729.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/vitaly-friedman.jpg
 ** module id = 432
 ** module chunks = 0
 **/